import React from 'react';

import { IconColor } from 'widget/shared/icons/BaseIcon';
import CrossIcon from 'widget/shared/icons/CrossIcon';

export type CloseButtonProps = {
  className?: string;
  onClick?: () => void;
};
const CloseButton: React.FC<CloseButtonProps> = ({ className, onClick }) => {
  return (
    <div className={className} onClick={onClick}>
      <CrossIcon color={IconColor.Main} />
    </div>
  );
};

export default CloseButton;
